import {
  Avatar,
  Dropdown,
  Button,
  MenuProps,
} from 'antd';
import React from 'react';
import {useRouter} from 'next/navigation';

import {clearHomeSortFromStorage} from '@/api/common-utils';
import styles from './style.module.scss';
// import {
//   CaretDownOutlined,
// } from '@ant-design/icons';
import {observer} from 'mobx-react-lite';
import {useStore} from '@/store/root-store';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowRightFromBracket} from '@fortawesome/pro-regular-svg-icons';

const UserMenu: React.FC<{name: string}> = observer(({name}) => {
  const router = useRouter();
  const onLogout = () => {
    localStorage.removeItem('currentCustomerId');
    localStorage.removeItem('reportBuilderIdAndDomain');
    clearHomeSortFromStorage();
    router.push('/login');
  };
  const menu: MenuProps = {
    items: [
      {
        label: (<Button type='link' className={styles.menuBtn} onClick={onLogout}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <FontAwesomeIcon icon={faArrowRightFromBracket} width={'12px'} style={{color: '#fff'}} />
            <span style={{fontSize: '14px', paddingLeft: '5px', color: 'white'}}>{'Logout'}</span>
          </div>
        </Button>),
        key: 'logout',
      },
    ],
    onClick: onLogout,
  };

  const {
    settings: {customer: {profile}},
  } = useStore('');
  const profileEmail = profile?.emailAddress?.split('@').reduce((acc, n)=>acc+n[0], '').toLocaleUpperCase();
  const avatarName = name.length ? name.split(' ').reduce((acc, n)=>acc+n[0], '').toLocaleUpperCase() : profileEmail;

  return (
    <Dropdown
      menu={menu}
      disabled
      trigger={['click']}
      className={styles.dropdown}
      overlayClassName={styles.menu}
      placement='bottomRight'
    >
      <div>
        <Avatar>{avatarName}</Avatar>{' '}
        <p style={{paddingLeft: '10px', color: '#4E5156', cursor: 'default'}}>{profile?.emailAddress}</p>
        {/* <span className={styles['down-icon']}><CaretDownOutlined /></span> */}
      </div>
    </Dropdown>
  );
});

export default UserMenu;
